export const DEFINITION_KEY_SEPARATOR = ':';
export var DefinitionTypeEnum;
(function (DefinitionTypeEnum) {
    DefinitionTypeEnum["VEHICLE"] = "vehicle";
    DefinitionTypeEnum["INFUSION"] = "infusion";
    DefinitionTypeEnum["CLASS_FEATURE"] = "class-feature";
    DefinitionTypeEnum["RACIAL_TRAIT"] = "racial-trait";
})(DefinitionTypeEnum || (DefinitionTypeEnum = {}));
